import Joi from 'joi';
import Form from '../common/form';
import PropTypes from 'prop-types';

import * as utils from '../../utils/utilities';

class HelideckInspectionWetForm extends Form {
	state = {
		data: {
			wetImages: [],
		},
		errors: {},
		loading: false,
		progress: 0,
		places: [],
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	schema = {
		wetImages: Joi.array().min(1).required().label('Wet Condition Images'),
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onProceed(this.state.data.wetImages);
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit} className="p-3">
				{this.renderFileInput({
					max: 4,
					multiple: true,
					name: 'wetImages',
					accept: 'image/*,application/pdf',
					label: 'Wet Condition Images',
					sublabel: 'Upload Wet Condition Images',
					types: utils.getFileUploadTypes(),
				})}

				<div className="d-flex justify-content-end">
					{this.renderButton('Proceed')}
				</div>
			</form>
		);
	}
}

export default HelideckInspectionWetForm;
